module.exports = require("protobufjs-cli/pbjs");